import { Plus } from "lucide-react";

interface PositPlusLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

const PositPlusLogo = ({ className = "", size = "md" }: PositPlusLogoProps) => {
  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return {
          text: "text-sm",
          icon: "h-3 w-3"
        };
      case "lg":
        return {
          text: "text-2xl",
          icon: "h-6 w-6"
        };
      default: // md
        return {
          text: "text-xl",
          icon: "h-5 w-5"
        };
    }
  };

  const { text, icon } = getSizeClasses();

  return (
    <span className={`font-bold flex items-center ${text} ${className}`}>
      <span className="bg-gradient-to-br from-primary via-primary-hover to-[#D946EF] bg-clip-text text-transparent">Posit</span>
      <Plus className={`${icon} -ml-0.5 stroke-[3] bg-gradient-to-br from-primary via-primary-hover to-[#D946EF] bg-clip-text`} />
    </span>
  );
};

export default PositPlusLogo;